import React from "react";

interface TextareaProps {
    label?: string,
    placeholder?: string,
    value: string,
    onChange: (value: string, prevValue: string) => void
}

const Textarea = (props: TextareaProps): JSX.Element => {
    const {label, placeholder, value, onChange, ...passedProps} = props;

    return (
        <div>
            {label && <div className="text-white">{label}</div>}
            <textarea value={value} onChange={(e) => onChange(e.target.value, value)}
                      placeholder={placeholder} {...passedProps}
                      className="bg-main-BG border-2 border-neutral-300 appearance-none h-20 text-white mt-5 rounded-md w-full py-2 px-3 text-gray-700 mb-3 leading-tight"
            />
        </div>
    );
};

export default Textarea;
